import { createContext, use } from "react";

import invariant from "tiny-invariant";

import { Holder } from "shared/stores/holder-store";

export const HolderContext = createContext<Holder | undefined>(undefined);

export const useHolder = () => {
  const data = use(HolderContext);
  invariant(data, `useHolder must be used within HolderContext.Provider`);

  return data;
};
